import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

const Footer = ({ siteTitle, menuLinks }) => (
  <section className="hero is-primary">
  <div className="container">
    <footer>
      <a id="ctgca" className="navbar-item">
        <Link to="/" id="ctgc" className="navbar-item" > © {new Date().getFullYear()} Monitaur Technologies Incorporated</Link>
      </a>
    </footer>
  </div>
  </section>
)

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer
